import { graphql, useStaticQuery } from 'gatsby';

const useNewPdpPageData = () => {
  const { contentfulPdpPage, allReviews } = useStaticQuery(graphql`
    query {
      contentfulPdpPage(title: { eq: "Thyroid Test-new" }) {
        title
        canonicalUrl
        metaTitle
        metaDescription {
          metaDescription
        }
        metaKeywords {
          metaKeywords
        }
        productSchema {
          name
          description
        }
        faqSchema {
          question
          answer
        }
        heroDescriptionHeader
        heroDescriptionText {
          heroDescriptionText
        }
        heroMeasuresText
        consultAvailable
        consultAvailableText
        heroPurchaseDetailsCallout
        heroSliderImages {
          gatsbyImageData(placeholder: BLURRED, quality: 75)
          description
        }
        heroBottomCallout
        heroDescriptionCallout
        heroMeasuresContentSection {
          listOfContentSections {
            title
            description {
              description
            }
            image {
              gatsbyImageData(placeholder: BLURRED, quality: 75)
              file {
                url
              }
            }
          }
        }
        heroModalButtonText
        heroModalTitle
        hideSubscription
        preSelectedSubscription
        heroSubscriptionFaqUrl
        pageSections {
          title
          sectionId
          headline
          subHeadline
          componentName
          modalButtonText
          listOfContentSections {
            sectionId
            headline
            slug
            subHeadline
            title
            description {
              description
            }
            cta {
              text
              url
            }
            image {
              gatsbyImageData(placeholder: BLURRED, quality: 75)
              description
              file {
                url
              }
            }
            desktopImages {
              title
              description
              gatsbyImageData(placeholder: BLURRED, quality: 75)
              file {
                url
              }
            }
            mobileImages {
              title
              description
              gatsbyImageData(placeholder: BLURRED, quality: 75)
              file {
                url
              }
            }
            embeddedVideoLink
            modalButtonText
            modalTitle
            slug
            pdfFile {
              file {
                url
              }
            }
            listOfContentSections {
              title
              image {
                file {
                  url
                }
                gatsbyImageData(placeholder: BLURRED, quality: 75)
              }
              description {
                description
              }
              cta {
                text
                url
              }
            }
          }
          noNumberTags
          cta {
            text
            url
          }
          description {
            description
          }
          desktopImages {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          mobileImages {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          comparisonList {
            title
            leftSide {
              title
              image {
                gatsbyImageData(placeholder: BLURRED, width: 96)
              }
              items {
                content
              }
            }
            rightSide {
              title
              image {
                gatsbyImageData(placeholder: BLURRED, width: 96)
              }
              items {
                content
              }
            }
          }
        }
        product {
          slug
          productId
          displayName
          description
          onSale
          outOfStock
          promoText
          category {
            title
          }
          primaryCallouts {
            ... on ContentfulPrimaryCallout {
              text
            }
          }
          collectionMethods {
            ... on ContentfulCollectionMethod {
              v2Name
              v2Icon {
                file {
                  url
                }
              }
            }
          }
          markerList {
            title
            markers {
              title
              description {
                description
              }
            }
          }
          digDeeperSections {
            question
            answer {
              answer
            }
          }
          heroImages {
            gatsbyImageData(placeholder: BLURRED, quality: 75)
            description
          }
        }
      }
      allReviews {
        nodes {
          product_name
          product_page_id
          average_rating
          native_review_count
          question_count
          rating_histogram
          recommended_ratio
          review_count
          syndicated_review_count
        }
      }
    }
  `);
  return { contentfulPdpPage, allReviews };
};
export default useNewPdpPageData;
